import { render, staticRenderFns } from "./BookingPropertyLabel.vue?vue&type=template&id=35155e44"
import script from "./BookingPropertyLabel.vue?vue&type=script&lang=js"
export * from "./BookingPropertyLabel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports